export default __webpack_public_path__ + "static/media/photo--sm--blitz-5.62dc931e.jpg";